import { useEffect, useRef, useState } from "react";
import Card from "../../../components/Card/Card";
import List from "../../../components/List/List";
import Pagination from "../../../components/Pagination/Pagination";
import SyncIcon from "../../../components/SyncIcon/SyncIcon";
import { useSSEContext } from "../../../contexts/sse";
import { useUserStore } from "../../../contexts/userStore";
import AntiPassbackService from "../../../services/AntiPassbackService";
import "./ListAntiPassbacks.css";

const ListAntiPassbacks = (props) => {
  const [antiPassbacks, setAntiPassbacks] = useState([]);
  const [maxPage, setMaxPage] = useState(1);
  const { selectedCondominio, selectedLicenceId } = useUserStore();
  const [currentPage, setCurrentPage] = useState(1);
  const { sseReceived } = useSSEContext();
  const [collumnClicked, setCollumnClicked] = useState({
    collumnTitle: "createdAt",
    orderDirection: "DESC",
  });
  const [isLoading, setIsLoading] = useState(true);
  const cancelTokenRef = useRef(null);

  const getAntiPassbacks = async (
    page,
    searchText,
    condominiumId,
    licenceId,
    collumnClicked
  ) => {
    if (condominiumId === 0 || !licenceId) return;
    if (cancelTokenRef.current) {
      cancelTokenRef.current.abort();
    }
    cancelTokenRef.current = new AbortController();
    setIsLoading(true);
    const response = await AntiPassbackService.listAntiPassbacksPaginated(
      page,
      searchText,
      condominiumId,
      licenceId,
      collumnClicked,
      cancelTokenRef.current.signal
    );
    setIsLoading(false);
    setAntiPassbacks(response.data?.items);
    setCurrentPage(page);
    setMaxPage(response.data?.totalPages);
  };

  useEffect(() => {
    getAntiPassbacks(
      currentPage,
      props.filters,
      selectedCondominio,
      selectedLicenceId,
      collumnClicked
    );
  }, [
    props.filters,
    selectedCondominio,
    selectedLicenceId,
    collumnClicked,
    props.refreshKey,
    currentPage
  ]);

  useEffect(() => {
    if (sseReceived?.action === "replyAntiPassbackReceived") {
      getAntiPassbacks(
        currentPage,
        props.filters,
        selectedCondominio,
        selectedLicenceId,
        collumnClicked
      );
    }
  }, [
    sseReceived,
  ]);

  return (
    <>
      <div className="list-container list-visibility">
        <List
          isLoading={isLoading}
          handleCollumnTitleClick={(collumnIndex) =>
            setCollumnClicked(collumnIndex)
          }
          listEntityName="antiPassbacks"
          collumsObjIndex={[
            { collumnLabel: "Nome", index: "name", type: "text" },
            {
              collumnLabel: "Habilitado",
              index: "enabled",
              type: "enabled",
            },
            { collumnLabel: "Status", index: "status", type: "sync-status" },
          ]}
          data={antiPassbacks}
        />
      </div>
      <div className="card-visibility">
        {antiPassbacks &&
          antiPassbacks.map((antiPassback, index) => (
            <Card
              key={index}
              data={antiPassback}
              delete={() => AntiPassbackService.deleteAntiPassback(antiPassback.id)}
              navigateOnDelete={"../consulta-antiPassbacks"}
              navigateOnEdit={"../cadastro-antiPassbacks"}
              aditionalButton1={
                <SyncIcon
                  isCard={true}
                  syncStatus={antiPassback.status}
                  data={antiPassback}
                  listEntityName={"antiPassbacks"}
                />
              }
            >
              <p className="card-content-title">{antiPassback.name}</p>
              <p className="card-content">
                Descrição: {antiPassback.description}
              </p>
            </Card>
          ))}
      </div>
      <Pagination
        rowsPerPage={8}
        maxPage={maxPage}
        changePage={(page) =>
          setCurrentPage(page)
        }
      />
    </>
  );
};

export default ListAntiPassbacks;
